import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";

import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import { Box, Button, Grid, Modal, Paper, Typography } from "@mui/material";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import staticVariablesApi from "../../../api/staticVariablesApi";
import helper from "../../../helper";
import stationApi from "../../../api/stationApi";
import roomApi from "../../../api/roomApi";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import hotelApi from "../../../api/hotelApi";
import hotelStructureApi from "../../../api/hotelStructureApi";
import BeatLoading from "../../../Components/Loader/BeatLoader";

import bedReservationApi from "../../../api/bedReservationApi";
import AllBedsByRoomId from "./AllBedsByRoomId";



const OverRoom = () => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);
    // const [rows, setRows] = useState([]);
    const [data, setData] = useState([])
    const [refresh, setRefresh] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);

    const [Cities, setCities] = useState([]);
    const [Hotels, setHotels] = useState([]);
    const [hotelStructureIds, setHotelStructureIds] = useState([])



    const onSubmit = (data) => {

        GetData(data.hotelStructureId);
    };

    useEffect(() => {
        GetCityDropDown();
    }, [])


    const RefreshGrid = (result) => {
        if (result)
            setRefresh(old => !old);
    }

    const GetData = (hotelStructureId) => {
        setLoadingRows(true);
        roomApi.GetOverRoomByHotelStrctureId(hotelStructureId)
            .then((res) => {
                setData(res.data.data)
            })
            .catch((error) => console.log(error))
            .finally(() => setLoadingRows(false));
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'floorNumber',
                header: 'طبقه',
                size: 100,
            },
            {
                accessorKey: 'roomNumber',
                header: 'شماره اتاق',
                Cell: ({ cell, row }) => (
                    <div dir='ltr'>
                        {
                            row.original.roomNumber
                        }
                    </div>
                ),
                size: 100,
            },
            {
                accessorKey: 'bedCount',
                header: 'تعداد تخت',
                size: 100,
            },


        ],
        [],
    );

    const schema = yup.object().shape({
        cityConsistency: yup.string().required("شهر را انتخاب نمایید"),
        hotelId: yup.string().required("هتل را انتخاب نمایید"),
        hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        defaultValues: {

        },
        resolver: yupResolver(schema),
    });

    const GetCityDropDown = () => {
        staticVariablesApi.GetArabicCityConsistencyDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                const mappedReponse = arr.map((r) => {
                    return {
                        id: r.key,
                        label: r.value
                    };
                });
                setCities(mappedReponse);
            })
            .catch((error) => console.log(error));
    };
    const handleCityChanged = useCallback(async (id) => {
        resetField("hotelId");
        resetField("hotelStructureId")
        resetField("planCode");
        setHotels(null);
        if (id) {
            const hotels = await fetchHotelsByCityConsistency(id);
            setHotels(
                hotels.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
        }
    }, []);
    const handleHotelChanged = useCallback(async (id) => {


        setHotelStructureIds([]);
        resetField("hotelStructureId")
        if (id) {
            const hotelStructureIds = await fetchHotelStrutureDropDown(id);
            const arr = helper.DictionayToList(hotelStructureIds);
            const mappedReponse = arr.map((r) => {
                return {
                    id: r.key,
                    label: r.value
                };
            });
            setHotelStructureIds(mappedReponse);

            if (arr.length === 1) {
                setValue("hotelStructureId", arr[0].key);

            }
        }

    }, []);
    const fetchHotelsByCityConsistency = async (cityConsistency) => {
        try {
            let res = await hotelApi.HotelDropDown(cityConsistency);
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };
    const fetchHotelStrutureDropDown = async (hotelId) => {
        try {
            let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
            if (res.status == 200) {
            }
            return res.data.data;
        }
        catch (err) {
            console.error(err);
        }
    };
    const handleHotelStructureIdChanged = async (id) => { };
    return (
        <RtlProvider>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Typography component="h1" variant="h5" mb={2}>رزرو تخت مازاد ظرفیت</Typography>
                <Grid container spacing={1} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={1.1}>
                        <RHFAutocomplete
                            control={control}
                            options={Cities ?? []}
                            name="cityConsistency"
                            placeholder="شهر"
                            onChange={handleCityChanged}
                            disabled={Cities === null}
                            error={!!errors?.cityConsistency}
                            helperText={errors?.cityConsistency?.message}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <RHFAutocomplete
                            control={control}
                            options={Hotels ?? []}
                            name="hotelId"
                            placeholder="هتل"
                            onChange={handleHotelChanged}
                            disabled={Cities === null}
                            error={!!errors?.hotelId}
                            helperText={errors?.hotelId?.message}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <RHFAutocomplete
                            loading={watch("hotelId") && !hotelStructureIds?.length}
                            control={control}
                            options={hotelStructureIds ?? []}
                            name="hotelStructureId"
                            placeholder="ساختار"
                            onChange={handleHotelStructureIdChanged}
                            disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
                            style={{
                                border: "none",
                                padding: 0,
                            }}
                            error={!!errors?.hotelStructureId}
                            helperText={errors?.hotelStructureId?.message}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6.9}>
                        <Button type="submit" variant="contained" color="secondary">جستجو</Button>
                    </Grid>
                </Grid>
            </form>

            <MaterialReactTable
                columns={columns}
                data={data}
                enableSelectAll={false}
                enableExpandAll={false}
                enableTopToolbar={false}
                enableBottomToolbar={false}
                enablePagination={false}
                enableSorting={false}
                enableColumnActions={false}
                mrtTheme={(theme) => ({
                    baseBackgroundColor: theme.palette.background.default, //change default background color
                })}
                muiTableProps={
                    {
                        sx: {
                            width: 'auto',
                            border: '1px solid rgba(81, 81, 81, .5)',
                            background: '#ffffff'
                        }
                    }
                }
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid rgba(81, 81, 81, .5)',
                        backgroundColor: '#86A7FC',
                        fontWeight: 'bold',
                        textAlign: 'left'
                    }
                }
                }
                muiTableBodyCellProps={
                    {
                        sx: {
                            border: '1px solid rgba(81, 81, 81, .5)',
                            textAlign: 'left',

                        }
                    }
                }
                muiTablePaperProps={
                    {
                        sx: { backgroundColor: 'transparent', boxShadow: 'none' }
                    }
                }
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: '', //change header text

                    },
                    'mrt-row-expand': {
                        header: '', //change header text

                    }
                }}
                renderDetailPanel={({ row }) => {
                    //    const items= GetAllBedsByRoomId(row.original.id);
                    //    console.log(items)
                    return (
                        <Box sx={{ padding: 2 }}>
                            <Typography variant="h6" gutterBottom component="div" style={{ textAlign: "right" }}>
                                لیست تخت
                            </Typography>
                            <AllBedsByRoomId roomid={row.original.id} />
                        </Box>
                    );
                }}
                state={{
                    isLoading: loadingRows,
                }}
            />

        </RtlProvider>
    );
}

export default OverRoom;
